import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "component/page/lead-import/style";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	open: boolean;
	validCount: number;
	invalidCount: number;
	onCancel: () => void;
	onConfirm: () => void;
}

const BypassImportDialogComponent: React.FC<Props> = ({
	open,
	validCount,
	invalidCount,
	onCancel,
	onConfirm,
	classes = {},
}) => {
	return (
		<Mui.Dialog open={open} onClose={onCancel}>
			<Mui.DialogTitle>Bypass Errors & Import Leads</Mui.DialogTitle>
			<Mui.DialogContent>
				<Mui.DialogContentText>
					Some leads in your file have issues and will not be imported.<br /><br />
					<strong>Leads that will be skipped:</strong><br />
					<ul className={classes.bypassList}>
						<li><strong>Duplicates:</strong> Leads with the same email as an existing lead in your account or another lead in the import file.</li>
						<li><strong>Errors:</strong> Leads with missing or incorrectly formatted information.</li>
					</ul>
					<Mui.Typography variant="body2" className={classes.bypassCounts}>
						<strong>{validCount}</strong> will be imported<br />
						<strong>{invalidCount}</strong> will be skipped
					</Mui.Typography>
					Only error-free, non-duplicate leads will be imported.
				</Mui.DialogContentText>
			</Mui.DialogContent>
			<Mui.DialogActions>
				<Mui.Button onClick={onCancel} color="primary" variant="outlined">
					Cancel
				</Mui.Button>
				<Mui.Button onClick={onConfirm} color={"primary"}>
					Confirm
				</Mui.Button>
			</Mui.DialogActions>
		</Mui.Dialog>
	);
};

export const BypassImportDialog = withStyles(BypassImportDialogComponent, styles);
